import React, { useState } from 'react';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import FormField from '@ingka/form-field';
import styled from 'styled-components';
import InputField from '@ingka/input-field';

export interface HashFullWidthProps {
  fullwidth?: string;
}

type Value = string | number;

interface ValidatedInputFieldProps extends HashFullWidthProps {
  id: string;
  type: string;
  label: string;
  value: Value;
  onChange: (val: React.ChangeEvent<HTMLInputElement>) => void;
  validatedField: string | null;
  onBlur?: () => void;
  req: boolean;
  isSubmitBtnClicked: boolean;
  disabled: boolean;
  autocomplete: string;
}

const StyledFormField = styled(FormField)`
  width: ${(props: HashFullWidthProps): string =>
    props.fullwidth ? '100%' : 'calc(50% - 10px)'};
`;

const StyledInputField = styled(InputField)`
  width: 100%;
  display: inline-block;
  margin: 0 0 0px;

  & input {
    width: 100%;
  }
`;

export const ValidatedInputField: React.FC<ValidatedInputFieldProps> = ({
  id,
  type,
  label,
  value,
  onChange,
  onBlur = (): void => {
    /**/
  },
  validatedField,
  fullwidth,
  req,
  isSubmitBtnClicked,
  disabled,
  autocomplete,
}): JSX.Element => {
  const { t } = useTranslation();
  const [validationId] = useState(`invalid-${Math.random().toString(36)}`);
  const isValid = !(isSubmitBtnClicked && validatedField !== null);

  return (
    <StyledFormField
      valid={isValid}
      shouldValidate={isSubmitBtnClicked}
      validation={{
        id: validationId,
        msg: t(validatedField as string),
      }}
      {...(fullwidth ? { fullwidth: fullwidth.toString() } : {})}
    >
      <StyledInputField
        id={id}
        type={type}
        label={label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        describedById={isValid ? undefined : validationId}
        req={req}
        disabled={disabled}
        autoComplete={autocomplete}
      />
    </StyledFormField>
  );
};
